import { employeeConstants } from '../constant/employee.constants';

// The initial state of the App
export const initialState = {
    employee: {
        id: 1,
        employeeCode: '',
        nickName: '',
        firstName: '',
        lastName: '',
        email: '',
        role: '',
        billable: '',
        status: '',
        employeePosition: [
            {
                positionId: '',
                positionCode: '',
                positionName: '',
                departmentId: '',
                departmentCode: '',
                departmentName: '',
                isMain: '1'
            }
        ],
        level: ''
    },
    dataEmployee: [],
    errorCode: '',
    successCode: '',
    isLoading: false
};

const employeeReducer = (state = initialState, action) => {
    switch (action.type) {
        case employeeConstants.GET_SUCCESS:
            return {
                ...state,
                dataEmployee: action.employeeList,
                isLoading: false
            };

        case employeeConstants.ADD_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };

        case employeeConstants.ADD_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };

        case employeeConstants.UPDATE_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };

        case employeeConstants.UPDATE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };

        case employeeConstants.DELETE_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };

        case employeeConstants.DELETE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        default:
            return state;
    }
};

export default employeeReducer;
